class FragranceSelector extends HTMLElement {
  constructor() {
    super();
    this.minSelection = parseInt(this.dataset.minSelection || '3', 10);
    this.maxSelection = parseInt(this.dataset.maxSelection || '5', 10);
    this.currencySymbol = this.dataset.currencySymbol || '$';
    this.selectedVariants = [];

    this.triggerBtn = this.querySelector('.fragrance-selector-trigger');
    this.backdrop = this.querySelector('.fragrance-modal-backdrop');
    this.modal = this.querySelector('.fragrance-modal');
    this.closeBtn = this.querySelector('.fragrance-modal__close');
    this.searchInput = this.querySelector('.fragrance-modal__search-input');
    this.counterText = this.querySelector('.fragrance-modal__counter-text');
    this.cards = Array.from(this.querySelectorAll('.fragrance-card'));
    this.summaryText = this.querySelector('.fragrance-modal__summary');
    this.modalCta = this.querySelector('.fragrance-modal__cta');
    this.ctaPriceSpan = this.querySelector('.fragrance-modal__cta-price');
    this.triggerSubtitle = this.querySelector('.fragrance-selector-trigger__subtitle');
    this.triggerTitle = this.querySelector('.fragrance-selector-trigger__title');
    
    // Main Add to Cart button on product page
    this.mainProductForm = document.querySelector('product-form.m-product-form--main');
    this.mainSubmitBtn = document.querySelector('button[name="add"].m-add-to-cart');

    this.init();
  }

  init() {
    // Append modal backdrop to document.body to break free from any parent container transforms
    if (this.backdrop && this.backdrop.parentElement !== document.body) {
      document.body.appendChild(this.backdrop);
    }

    if (this.triggerBtn) {
      this.triggerBtn.addEventListener('click', () => this.openModal());
    }

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.closeModal());
    }

    if (this.backdrop) {
      this.backdrop.addEventListener('click', (e) => {
        if (e.target === this.backdrop) this.closeModal();
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.backdrop && this.backdrop.classList.contains('is-open')) {
        this.closeModal();
      }
    });

    if (this.searchInput) {
      this.searchInput.addEventListener('input', (e) => this.handleSearch(e.target.value));
    }

    this.cards.forEach((card) => {
      card.addEventListener('click', () => this.toggleCard(card));
    });

    if (this.modalCta) {
      this.modalCta.addEventListener('click', () => this.handleConfirmSelection());
    }

    // Intercept main product form submit if not enough fragrances selected
    if (this.mainSubmitBtn) {
      this.mainSubmitBtn.addEventListener('click', (e) => {
        if (this.selectedVariants.length < this.minSelection) {
          e.preventDefault();
          e.stopPropagation();
          this.openModal();
        }
      }, true);
    }

    // Listen to quantity changes on the product page
    const form = document.querySelector('product-form.m-product-form--main form') || document.querySelector('form[action*="/cart/add"]');
    if (form) {
      const visibleQtyInput = document.querySelector(`input.m-quantity__input[form="${form.id}"]`) || form.querySelector('input.m-quantity__input');
      if (visibleQtyInput) {
        visibleQtyInput.addEventListener('change', () => this.updateState());
        visibleQtyInput.addEventListener('input', () => this.updateState());
        const qtyWrapper = visibleQtyInput.closest('m-quantity-input');
        if (qtyWrapper) {
          qtyWrapper.addEventListener('click', () => {
            setTimeout(() => this.updateState(), 50);
          });
        }
      }
      form.addEventListener('submit', () => this.syncFormProperties());
    }

    // Initial state calculation
    this.updateState();
  }

  getPackQuantity() {
    const form = document.querySelector('product-form.m-product-form--main form') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return 1;
    const visibleQtyInput = document.querySelector(`input.m-quantity__input[form="${form.id}"]`) || form.querySelector('input.m-quantity__input');
    if (visibleQtyInput) {
      const val = parseInt(visibleQtyInput.value, 10);
      return isNaN(val) || val < 1 ? 1 : val;
    }
    return 1;
  }

  openModal() {
    if (this.backdrop) {
      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout);
        this.closeTimeout = null;
      }
      // Prevent page layout shift (shaking) by compensating for scrollbar width
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`;
      }
      document.body.style.overflow = 'hidden';
      this.backdrop.classList.add('is-open');

      if (this.searchInput) {
        setTimeout(() => {
          this.searchInput.focus({ preventScroll: true });
        }, 120);
      }
    }
  }

  closeModal() {
    if (this.backdrop) {
      this.backdrop.classList.remove('is-open');
      // Smoothly restore body scroll after fade transition
      this.closeTimeout = setTimeout(() => {
        if (!this.backdrop.classList.contains('is-open')) {
          document.body.style.overflow = '';
          document.body.style.paddingRight = '';
        }
      }, 230);
    }
  }

  handleSearch(query) {
    const q = query.toLowerCase().trim();
    const cards = this.backdrop ? Array.from(this.backdrop.querySelectorAll('.fragrance-card')) : Array.from(this.querySelectorAll('.fragrance-card'));
    cards.forEach((card) => {
      const title = (card.dataset.variantTitle || card.textContent || '').toLowerCase();
      if (!q || title.includes(q)) {
        card.classList.remove('is-hidden');
      } else {
        card.classList.add('is-hidden');
      }
    });
  }

  toggleCard(card) {
    const id = card.dataset.variantId;
    const price = parseFloat(card.dataset.variantPrice || '0');
    const title = card.dataset.variantTitle || '';

    const existingIndex = this.selectedVariants.findIndex((v) => v.id === id);

    if (existingIndex > -1) {
      // Unselect
      this.selectedVariants.splice(existingIndex, 1);
      card.classList.remove('is-selected');
    } else {
      // Check max limit
      if (this.selectedVariants.length >= this.maxSelection) {
        return;
      }
      this.selectedVariants.push({ id, price, title });
      card.classList.add('is-selected');
    }

    this.updateState();
  }

  updateState() {
    const count = this.selectedVariants.length;

    // Update Counter
    if (this.counterText) {
      this.counterText.textContent = `Selected: ${count} / ${this.maxSelection}`;
    }

    // Pack Quantity
    const packQty = this.getPackQuantity();

    // Update Subtotal Price (Sum of selected variant prices multiplied by pack quantity)
    const singlePackPrice = this.selectedVariants.reduce((sum, v) => sum + v.price, 0);
    const totalPrice = singlePackPrice * packQty;
    const formattedPrice = this.formatMoney(totalPrice);

    // Update Disabled States for Cards if Max Reached
    const isMaxReached = count >= this.maxSelection;
    this.cards.forEach((card) => {
      const isSelected = card.classList.contains('is-selected');
      if (isMaxReached && !isSelected) {
        card.classList.add('is-disabled');
      } else {
        card.classList.remove('is-disabled');
      }
    });

    // Validate Minimum Selection
    const isValid = count >= this.minSelection && count <= this.maxSelection;

    // Update Footer Summary & CTA Button
    if (this.summaryText) {
      this.summaryText.textContent = `Selected: ${count} fragrance(s)`;
    }

    if (this.modalCta) {
      this.modalCta.disabled = !isValid;
    }

    if (this.ctaPriceSpan) {
      this.ctaPriceSpan.textContent = count > 0 ? ` · ${this.formatMoney(singlePackPrice)}` : '';
    }

    // Sync with Main Product Page Selector Box
    if (this.triggerSubtitle) {
      if (count > 0) {
        let listHtml = `
          <div class="fragrance-selected-header">
            <span class="fragrance-count-badge">${count} Selected</span>
            <span class="fragrance-edit-hint">(Click to edit)</span>
          </div>
          <div class="fragrance-selected-list">
        `;
        this.selectedVariants.forEach((v, index) => {
          listHtml += `
            <div class="fragrance-selected-item">
              <span class="fragrance-selected-item__num">${index + 1}</span>
              <span class="fragrance-selected-item__name">${v.title}</span>
            </div>
          `;
        });
        listHtml += `</div>`;
        this.triggerSubtitle.innerHTML = listHtml;
        if (this.triggerBtn) this.triggerBtn.classList.add('has-selection');
      } else {
        this.triggerSubtitle.textContent = `Select ${this.minSelection} to ${this.maxSelection} fragrances`;
        if (this.triggerBtn) this.triggerBtn.classList.remove('has-selection');
      }
    }

    // Sync with Main Page Add to Cart Button if present
    if (this.mainSubmitBtn) {
      if (isValid) {
        this.mainSubmitBtn.disabled = false;
        const mainText = this.mainSubmitBtn.querySelector('.m-add-to-cart--text');
        if (mainText) {
          mainText.textContent = `Add to Cart · ${formattedPrice}`;
        }
      } else {
        this.mainSubmitBtn.disabled = true;
        const mainText = this.mainSubmitBtn.querySelector('.m-add-to-cart--text');
        if (mainText) {
          mainText.textContent = `Select ${this.minSelection}-${this.maxSelection} Fragrances`;
        }
      }
    }

    // Sync line item properties and total quantity with the main form
    this.syncFormProperties();
  }

  formatMoney(centsOrNumber) {
    let amount = centsOrNumber;
    // Handle cents if integer > 100
    if (Number.isInteger(centsOrNumber) && centsOrNumber > 1000) {
      amount = centsOrNumber / 100;
    }
    return `${this.currencySymbol}${amount.toFixed(2)}`;
  }

  handleConfirmSelection() {
    if (this.selectedVariants.length < this.minSelection) return;

    this.syncFormProperties();
    this.closeModal();
    this.updateState();
  }

  syncFormProperties() {
    const form = document.querySelector('product-form.m-product-form--main form') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    const count = this.selectedVariants.length;
    const packQty = this.getPackQuantity();
    const totalQty = (count >= this.minSelection ? count : 1) * packQty;

    // Change visible input name away from 'quantity' so it doesn't conflict
    const visibleQtyInput = document.querySelector(`input.m-quantity__input[form="${form.id}"]`) || form.querySelector('input.m-quantity__input');
    if (visibleQtyInput && visibleQtyInput.name === 'quantity') {
      visibleQtyInput.name = '_pack_quantity';
    }

    // Ensure hidden actual quantity input exists in form (for ATC & Shop Pay / Accelerated Checkout)
    let actualQtyInput = form.querySelector('input[name="quantity"].fragrance-actual-quantity');
    if (!actualQtyInput) {
      actualQtyInput = document.createElement('input');
      actualQtyInput.type = 'hidden';
      actualQtyInput.name = 'quantity';
      actualQtyInput.className = 'fragrance-actual-quantity';
      form.appendChild(actualQtyInput);
    }
    actualQtyInput.value = totalQty;

    // Remove existing fragrance properties
    form.querySelectorAll('.fragrance-hidden-prop').forEach((el) => el.remove());

    // Add properties for each selected fragrance ONLY (Fragrance 1, Fragrance 2, ...)
    this.selectedVariants.forEach((v, index) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[Fragrance ${index + 1}]`;
      input.value = v.title;
      input.className = 'fragrance-hidden-prop';
      form.appendChild(input);
    });

    // Add hidden bundle size property
    if (count > 0) {
      const bundleSizeInput = document.createElement('input');
      bundleSizeInput.type = 'hidden';
      bundleSizeInput.name = 'properties[_bundle_size]';
      bundleSizeInput.value = count;
      bundleSizeInput.className = 'fragrance-hidden-prop';
      form.appendChild(bundleSizeInput);
    }
  }
}

if (!customElements.get('fragrance-selector')) {
  customElements.define('fragrance-selector', FragranceSelector);
}
